<script lang="ts">
  // The brand motif: a seed sprouting. `stage` grows it from seed (1) to
  // fruiting (4); used as the logo mark (stage 2) and in the learning garden.
  let {
    size = 24,
    stage = 2,
    soil = false,
    class: klass = "",
  }: { size?: number; stage?: 1 | 2 | 3 | 4; soil?: boolean; class?: string } =
    $props();
</script>

<svg
  class="sprout {klass}"
  width={size}
  height={size}
  viewBox="0 0 32 32"
  fill="none"
  aria-hidden="true"
>
  {#if soil}
    <path
      d="M5 27 Q16 24 27 27"
      stroke="var(--terra)"
      stroke-width="2"
      stroke-linecap="round"
      opacity="0.7"
    />
  {/if}

  <!-- stem -->
  <path
    class="stem"
    d="M16 {soil ? 27 : 30} C 16 24 16 18 16 {stage >= 3 ? 9 : 12}"
    stroke="var(--green-deep)"
    stroke-width="2.1"
    stroke-linecap="round"
  />

  {#if stage === 1}
    <!-- just-sprouted seed leaf -->
    <ellipse cx="16" cy="16" rx="4.2" ry="2.4" fill="var(--sprout)" transform="rotate(-20 16 16)" />
  {:else}
    <!-- right leaf -->
    <path
      class="leaf leaf-r"
      d="M16 {stage >= 3 ? 17 : 19} C 21 {stage >= 3 ? 16 : 18} 26 {stage >= 3 ? 12 : 14} 27 {stage >= 3 ? 6 : 9} C 21 {stage >= 3 ? 7 : 10} 16 {stage >= 3 ? 11 : 13} 16 {stage >= 3 ? 17 : 19} Z"
      fill="var(--sprout)"
    />
    <!-- left leaf -->
    <path
      class="leaf leaf-l"
      d="M16 {stage >= 3 ? 14 : 16} C 11 {stage >= 3 ? 13 : 15} 6 {stage >= 3 ? 9 : 11} 5 {stage >= 3 ? 4 : 7} C 11 {stage >= 3 ? 5 : 8} 16 {stage >= 3 ? 9 : 11} 16 {stage >= 3 ? 14 : 16} Z"
      fill="var(--green)"
    />
  {/if}

  {#if stage === 4}
    <!-- fruit / bloom -->
    <circle cx="16" cy="7" r="3.1" fill="var(--terra)" />
    <circle cx="16" cy="7" r="1.1" fill="var(--paper-card)" opacity="0.7" />
  {/if}
</svg>

<style>
  .sprout {
    display: block;
    overflow: visible;
  }
  .leaf {
    transform-box: fill-box;
    transform-origin: bottom center;
  }
</style>
